export const SKU_TAB_OPTIONS = [
    {
      label: 'Buy Load',
      route: '/features/sku-biller-all-transaction',
    },
    {
      label: 'Cash In',
      route: '/features/sku-cash-in'
    },
    {
      label: 'Pay Bills',
      route: '/features/sku-pay-bills'
    },
    {
      label: 'Stores',
      route: '/features/sku-stores'
    },
    {
      label: 'Redeem',
      route: '/features/sku-redeem',
      permission: 'megapay.skusBillers.redeem.view'
    },
    {
      label: 'Disbursement',
      route: '/features/sku-disbursement-institutions',
      permission: 'megapay.skusBillers.disbursementInstitutions.view'
    }
];

export const TRANSACTION_TAB_OPTIONS = [
  {
    label: 'All Transaction',
    route: '/transactions/all-transaction',
  },
  {
    label: 'Buy Load',
    route: '/transactions/buy-load',
  },
  {
    label: 'Cash In',
    route: '/transactions/cash-in',
  },
  {
    label: 'Pay Bills',
    route: '/transactions/pay-bills',
  },
  {
    label: 'Transfer Funds',
    route: '/transactions/transfer-funds',
  },
  {
    label: 'Store Purchase',
    route: '/transactions/store-purchase',
  },
  {
    label: 'Mega Rewards',
    route: '/transactions/mega-reward',
  },
  // {
  //   label: 'Promo',
  //   route: '/transactions/promo',
  // },
  {
    label: 'Redeem',
    route: '/transactions/redeem',
  },
  {
    label: 'Overview',
    route: '/transactions/overview',
  },
];

export const SYSTEM_MAINTAINANCE_TAB_OPTIONS = [
  {
    label: 'App Maintenance',
    route: 'admin/system-maintenance/app-maintanance',
  },
  {
    label: 'Redeem',
    route: 'admin/system-maintenance/redeem',
  },
  {
    label: 'Cashout Configuration',
    route: 'admin/system-maintenance/cashout-configuration',
  },
  {
    label: 'Rebates',
    route: 'admin/system-maintenance/rebate-settings',
  },
  {
    label: 'Features',
    route: 'admin/system-maintenance/tier-features',
  }
];
